import { useState, useEffect } from "react";
import { TextField, Box, Button, Autocomplete } from "@mui/material";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Detail from "../../main/detail/Detail";
import { UseCustomerRetention } from "./UseCustomerRetention";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditCampaign() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const [disCode, setDisCode] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [patterns, setPatterns] = useState();
  const [expireDate, setExpireDate] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { isSmall } = useBreakpoints();

  const {
    getAllDiscountCode,
    getCampaignByID,
    getAllPatternList,
    validate2,
    updateCampaign,
  } = UseCustomerRetention();

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    paternID: undefined,
    expiredate: undefined,
    discountCode: undefined,
    discountCodeID: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    paternID: false,
    expiredate: false,
    discountCodeID: false,
  });

  useEffect(() => {
    getAllPatternList((callback) => {
      setPatterns(callback.items);
    });
  }, []);

  const { toSolar } = require("jdate-convert");

  useEffect(() => {
    getAllDiscountCode((callback) => {
      setDisCode(callback.codes);
    });
    if (location.state && location.state.id) {
      getCampaignByID(location.state.id, (callback) => {
        setState({
          id: callback.id,
          title: callback.title,
          paternID: callback.paternID,
          expiredate: callback.expiredate
            ? callback.expiredate.split("T")[0]
            : "",
          discountCode: callback.discountCode,
          discountCodeID: callback.discountCodeID,
        });
      });
    }
  }, [location.state]);

  useEffect(() => {
    let newValueStart = expireDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, expiredate: newValueStart });
  }, [expireDate]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/customerretention" },
          { name: "ویرایش کمپین", url: "/customerretention/editCampaign" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <TextField
            label="عنوان"
            error={errorState.title}
            value={state.title ? state.title : ""}
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            size="small"
            fullWidth
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          {patterns && (
            <Autocomplete
              size="small"
              value={state.paternID ? state.paternID : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, paternID: newValue });
                } else {
                  setState({ ...state, paternID: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return patterns?.find((m) => m.id == option).title;
                }
                return "";
              }}
              fullWidth
              options={patterns?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.paternID}
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="الگو"
                />
              )}
            />
          )}
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          {disCode && (
            <Autocomplete
              size="small"
              value={state.discountCodeID ? state.discountCodeID : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, discountCodeID: newValue });
                } else {
                  setState({ ...state, discountCodeID: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return disCode?.find((m) => m.id == option)?.discountCode
                    ? disCode.find((m) => m.id == option).discountCode
                    : "";
                }
                return "";
              }}
              fullWidth
              options={disCode?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.discountCodeID}
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="کد تخفیف"
                />
              )}
            />
          )}
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            label="عنوان"
            value={state.discountCode ? state.discountCode : ""}
            size="small"
            sx={{ input: { textAlign: "center" } }}
            fullWidth
            variant="filled"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <DatePicker
            // highlightToday={false}
            onOpenPickNewDate={false}
            weekDays={weekDays}
            calendar={persian}
            locale={persian_fa}
            format="YYYY-MM-DD"
            value={state && state.expiredate ? toSolar(state.expiredate) : ""}
            onChange={setExpireDate}
            containerStyle={{
              width: "100%",
            }}
            render={
              <TextField
                error={errorState.expiredate}
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                size="small"
                fullWidth
                label="تاریخ انقضا"
              />
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 4"}
          sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate2(state, setErrorState) == 200) {
                setProgress(true);
                updateCampaign(state, () => {
                  navigate("/customerretention", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/customerretention", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
